import { z } from "zod";

export const marineForecastSchema = z.object({
	data: z.array(
		z.object({
			station_id: z.string(),
			timestep: z.string(),
			temperature_2m: z.number(),
			wind_speed_10m: z.number(),
			wind_direction_10m: z.number(),
			wave_height: z.number().nullable(),
			wave_direction: z.number().nullable(),
			current_speed: z.number(),
			wave_period: z.number().nullable(),
			sea_surface_temperature: z.number(),
			tidal_elevation: z.number().nullable(),
		}),
	),
});

export type IMarineForecast = z.infer<typeof marineForecastSchema>;
export type IMarineForecastData = z.infer<typeof marineForecastSchema>["data"];
export type IParamType = keyof IMarineForecastData[number];
